<template>
  <v-card class="elevation-0 shadow white mt-3 pb-3 flex mt-3">
    <v-card-text>
      <div class="flex-row align-center justify-start">
        <div class="py-2 px-3 mb-2 lable-out">
          <h4>{{ title }}</h4>
        </div>
        <v-spacer />
        <v-btn
          color="grey darken-2"
          class="ml-0"
          flat
          icon
          @click="printTable(false)"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          color="grey darken-2"
          class="mx-0"
          flat
          icon
          @click="printTable(true)"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </div>
      <v-data-table hide-actions :items="customers" :headers="headers">
        <template slot="items" slot-scope="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td
              v-for="currency in currencies"
              :key="`${index}${currency.id}`"
              class="font-weight-bold"
              :class="{
                'red--text': item[currency.id] < 0,
                'activeColor--text': item[currency.id] > 0,
              }"
            >
              {{ item[currency.id] | currency }}
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <tr />
        </template>
        <template slot="footer">
          <tr>
            <td colspan="2" class="font-weight-medium body-2">
              {{ total.name }}
            </td>
            <td
              :key="`barrow${currency.id}`"
              v-for="currency in currencies"
              class="font-weight-medium body-2"
            >
              {{ total[currency.id] | currency({ symbol: smbl(currency.id) }) }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import curjs from "currency.js";
export default {
  props: {
    title: "",
    brnch_name: "",
    customers: { default: () => [] },
    currencies: { default: () => [] },
  },

  computed: {
    headers() {
      let items = [
        {
          width: "50px",
          sortable: false,
          text: this.$t("number"),
        },
        {
          value: "name",
          width: "200px",
          sortable: false,
          text: this.$t("name"),
        },
      ];
      this.currencies.forEach((item) => {
        let va = item.id;
        items.push({
          value: va,
          text: item.name,
          sortable: false,
          computed: (item) => curjs(item[va]).format({ symbol: "" }),
        });
      });
      return items;
    },

    total() {
      let total = { name: this.$t("total") };
      this.customers.forEach((item) => {
        this.currencies.forEach((currency) => {
          total[currency.id] = curjs(total[currency.id] || 0).add(
            item[currency.id] || 0
          ).value;
        });
      });

      return total;
    },
  },

  methods: {
    printTable(excel) {
      let items = this.customers;
      items.push(this.total);

      let data = {
        items: items,
        landscape: false,
        title: this.title,
        brnch_name:this.brnch_name,
        headers: this.headers.slice(1),
      };

      if (excel)
        return this.xl_tables(data, "branch-accounts", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
};
</script>
 